import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatListModule } from '@angular/material/list'
import { ReasonService } from '../../../core/services/reason/reason/reason.service'
import { TelefonePipe } from '../../../shared/pipes/phone.pipes'

@Component({
  selector: 'modal-create-contract',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDivider,
    MatProgressBar,
    MatListModule,
    TelefonePipe,
  ],
  templateUrl: './modal-create-contract.component.html',
  styleUrl: './modal-create-contract.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalCreateContractComponent implements OnInit {
  constructor(
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalCreateContractComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  @Output() responseCreate = new EventEmitter()
  item: any = {}
  loading: boolean = false

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  createContract() {
    this.loading = true
    const model = {
      propostaId: this.item.id,
    }
    this.proposalClientService.createContract(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit(true)
        this.close()
        this.loading = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.errorRequest(err)
      },
      complete: () => {},
    })
  }
}
